<template>
  <div class="d-flex justify-content-between align-items-center border-bottom w-100">
    <div>
      <b-button
        class="btn-icon rounded-circle"
        variant="link"
        @click="$emit('update:section', null)"
      >
        <feather-icon
          v-show="section"
          icon="ArrowLeftIcon"
          size="18"
          class="text-secondary"
        />
      </b-button>
    </div>
    <div class="flex-grow-1 text-secondary text-center font-weight-bold">
      {{ $t('help.help') }}
    </div>
    <b-button
      class="btn-icon rounded-circle"
      variant="link"
      @click="$emit('close')"
    >
      <feather-icon
        icon="XIcon"
        size="18"
        class="text-secondary"
      />
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'HelpModalHeader',
  components: {
    BButton,
  },
  props: {
    section: {
      type: Object,
      default: null,
    },
  },
}
</script>
